const env = process.env.VUE_APP_BUILD;
export const STRIPE_KEY =
  env === "prod" || env === "release"
    ? "pk_live_VosCUGxMkN0l7zmwBOdWZOAC"
    : "pk_test_EEKEVOfxBKxFTyNwJbJgWCPh";
// uat环境暂时用测试key 之后上线再改
// export const STRIPE_KEY = 'pk_test_EEKEVOfxBKxFTyNwJbJgWCPh'
